import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';

import { UiIconModule } from '@cigna/ui/icon';
import { UiButtonModule } from '@cigna/ui/button';
import { AnalyticsUiModule } from '@cigna/analytics/ui';

import { ChcpSharedUiModule } from '@cigna/chcp/shared/ui';
import { ChcpSharedEnvironmentUtilModule } from '@cigna/chcp/shared/environment-util';

import { LatestUpdateItemComponent } from './latest-update-item/latest-update-item.component';
import { PatientDetailItemComponent } from './patient-detail-item/patient-detail-item.component';
import { ClaimDetailItemComponent } from './claim-detail-item/claim-detail-item.component';
import { ClaimDetailListComponent } from './claim-detail-list/claim-detail-list.component';
import { PatientDetailListComponent } from './patient-detail-list/patient-detail-list.component';
import { NewFeaturesComponent } from './new-features/new-features.component';
import { NewFeaturesDialogComponent } from './new-features-dialog/new-features-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    UiIconModule,
    UiButtonModule,
    MatDialogModule,
    RouterModule,
    ChcpSharedUiModule,
    ChcpSharedEnvironmentUtilModule,
    AnalyticsUiModule,
  ],
  declarations: [
    LatestUpdateItemComponent,
    PatientDetailItemComponent,
    ClaimDetailItemComponent,
    ClaimDetailListComponent,
    PatientDetailListComponent,
    NewFeaturesComponent,
    NewFeaturesDialogComponent,
  ],
  exports: [
    LatestUpdateItemComponent,
    NewFeaturesComponent,
    PatientDetailItemComponent,
    ClaimDetailItemComponent,
    ClaimDetailListComponent,
    PatientDetailListComponent,
  ],
  entryComponents: [NewFeaturesDialogComponent],
})
export class ChcpDashboardUiModule {}
